<div class="flex items-center justify-between max-w-120">
  <div class="text-sm md:text-md leading-4">
    The app is in public beta testing mode. It may contain bugs or other issues that could affect its performance. We appreciate your patience and understanding as we work to improve it.
  </div>
  <button mat-icon-button (click)="snackBarRef.dismissWithAction()">
    <mat-icon svgIcon="mat_outline:close"></mat-icon>
  </button>
</div>